import { DetailedHTMLProps, FunctionComponent, ImgHTMLAttributes } from 'react';
import LoadingGifCardsPath from 'Assets/Images/loading.gif';

type SVGProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
const LoadingGifCards: FunctionComponent<SVGProps> = ({ className, ...props }) => {
  return <img 
    src={LoadingGifCardsPath} 
    alt="" aria-hidden={true}
    className={'loadingGifCards ' + className || ''} {...props} 
    />;
};

export default LoadingGifCards;
